<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-21 20:47:59
-->
<template>
    <div class="add-danwei">
        <el-form
            ref="ruleForm"
            :model="viewData"
            :rules="rules"
            label-width="100px"
        >
            <el-form-item label="租售类型" prop="type">
                <span v-if="viewData.type == 1">出租</span>
                <span v-if="viewData.type == 2">出售</span>
                <span v-if="viewData.type == 3">求租</span>
                <span v-if="viewData.type == 4">求购</span>
            </el-form-item>
            <el-form-item label="小区" prop="commId">
                <span v-if="viewData.community">{{ viewData.community.commName }}</span>
            </el-form-item>
            <el-form-item label="资源类型" prop="commId">
                <span v-if="viewData.zushou_type == 1">住宅</span>
                <span v-if="viewData.zushou_type == 2">车位</span>
                <span v-if="viewData.zushou_type == 3">车库</span>
                <span v-if="viewData.zushou_type == 4">储间</span>
                <span v-if="viewData.zushou_type == 5">商业</span>
                <span v-if="viewData.zushou_type == 6">写字楼</span>
            </el-form-item>
            <el-form-item label="车位号" prop="commId" v-if="viewData.zushou_type==2">
                <span >
                   {{ viewData.zushou_name }}
                </span>
            </el-form-item>
            <el-form-item label="车库号" prop="commId" v-if="viewData.zushou_type==3">
                <span >
                   {{ viewData.zushou_name }}
                </span>
            </el-form-item>
            <el-form-item label="储间号" prop="commId" v-if="viewData.zushou_type==4">
                <span >
                   {{ viewData.zushou_name }}
                </span>
            </el-form-item>
             <el-form-item label="房号" prop="commId" v-if="viewData.zushou_type>4">
                <span >
                   {{ viewData.zushou_name }}
                </span>
            </el-form-item>
            <el-form-item label="室" v-if="viewData.zushou_type==1">
                {{ viewData.shi }}
            </el-form-item>
            <el-form-item label="厅" v-if="viewData.zushou_type==1">
                {{ viewData.ting }}
            </el-form-item>
            <el-form-item label="卫" v-if="viewData.zushou_type==1">
                {{ viewData.wei }}
            </el-form-item>
            <el-form-item label="楼层" v-if="viewData.zushou_type==1||viewData.zushou_type==6">
                {{ viewData.floor }}
            </el-form-item>
            <el-form-item label="面积" v-if="viewData.zushou_type==1||viewData.zushou_type>4">
                {{ viewData.area }}
            </el-form-item>
             <el-form-item label="位置" v-if="viewData.zushou_type==5">
                {{ viewData.address }}
            </el-form-item>
            <el-form-item label="价格" prop="price" v-if="viewData.type==1">
                <el-input v-model="viewData.price" />
                <span v-if="viewData.zushou_type==5">元/年</span>
                <span v-else-if="viewData.zushou_type==6">元/平米每天</span>
                <span v-else>元/月</span>
            </el-form-item>
            <el-form-item label="价格" prop="price" v-else>
                <el-input v-model="viewData.price" />
            </el-form-item>
            <el-form-item label="联系人">
                {{ viewData.person }}
            </el-form-item>
            <el-form-item label="联系方式">
                {{ viewData.phone }}
            </el-form-item>
            <el-form-item label="封面图">
                <el-image
                    style="width: 100px; height: 100px"
                    v-for="(item,idx) in imageDefaultList1"
                    :key="idx"
                    :src="item.url"
                    :preview-src-list="[item.url]">
                </el-image>
            </el-form-item>
            <el-form-item label="图片数组">
                <el-image
                    style="width: 100px; height: 100px;margin-right: 10px;"
                    v-for="(item,idx) in imageDefaultList"
                    :key="idx"
                    :src="item.url"
                    :preview-src-list="[item.url]">
                </el-image>
            </el-form-item>
            <el-form-item label="详情"
                            prop="content">
                <div v-html="viewData.content"></div>
            </el-form-item>
            <!-- <el-form-item label="发布时间">
            <el-date-picker v-model="viewData.publish_at"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="发布时间">
            </el-date-picker>
          </el-form-item> -->

          <!-- <el-form-item label="来源">
                <el-input v-model="viewData.source" />
            </el-form-item>
            <el-form-item label="排序">
                <el-input-number
                    size="mini"
                    style="width: 100px"
                    v-model="viewData.sort"
                    controls-position="right"
                    :min="0"
                ></el-input-number>
            </el-form-item> -->
            <el-form-item label="是否置顶">
                <span v-if="viewData.is_top == 1">是</span>
                <span v-if="viewData.is_top == 0">否</span>
            </el-form-item>
            <!-- <el-form-item label="是否banner">
                <span v-if="viewData.is_banner == 1">是</span>
                <span v-if="viewData.is_banner == 0">否</span>
            </el-form-item> -->
        </el-form>
        <!-- <div class="fix-fotter">
            <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;border-color: #1067E0;" size="mini" type="primary" @click="tijiao('ruleForm')">提交</el-button>
        </div> -->
    </div>
</template>

<script>
import ImageUpload from "@/components/Upload/image";
import fetch from "@/api/tianzheng/sell";
import Qu from "@/api/tianzheng/Qu";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
    data() {
        return {
            thumbList: [],
            imageDefaultList: "",
            thumbList1: [],
            imageDefaultList1: "",
            showUpload:false,
            optionList: [],
            viewData: {
                id:'',
                name: "",
                commId: "",
                content: "",
                source: "",
                publish_at: "",
                sort: 0,
                status: 1,
            },
            rules: {
                title1: [
                    {
                        required: true,
                        message: "请输入标题",
                        trigger: "blur",
                    },
                ],
                commId1: [
                    {
                        required: true,
                        message: "请选择小区",
                        trigger: "blur",
                    },
                ],
                content1: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    components: {
        Pagination,
        ImageUpload
    },
    created() {
        this.getSelectCity()
    },
    methods: {
        // 更新图片
        onUpdateImg1 (val) {
            let thumbList = [];
            val.forEach((ele, idx) => {
                thumbList.push(ele.path);
            });
            this.thumbList1 = thumbList;
        },
        // 更新图片
        onUpdateImg (val) {
            let thumbList = [];
            val.forEach((ele, idx) => {
                thumbList.push(ele.path);
            });
            this.thumbList = thumbList;
        },
        // 获取下拉列表
        getSelectCity () {
            Qu.select({}).then(res => {
                if (res.code == 200) {
                this.optionList = res.result;
                }
            })
        },
        /**
         * @name: 初始化列表
         * @param {*} obj
         * @return {*}
         * @desc:
         */
        initFun(obj) {
            let that = this
            this.viewData = {
                id: "",
                name: "",
                status: 1,
                sort: 0,
            }
            this.showUpload = true
            if (obj.id) {
                // 编辑
                this.viewData.id = obj.id;
                fetch.detail({ id: obj.id }).then((res) => {
                    console.log(res)
                    if (res.code == 200) {
                        that.viewData = res.result
                        that.viewData.id = res.result.id;
                        if (that.viewData.thumb) {
                            let arr = []
                            let obj = {
                                    name: that.viewData.thumb,
                                    path: that.viewData.thumb,
                                    url: that.$publicData.imgUrl + that.viewData.thumb,
                                }
                                arr.push(obj);
                                that.imageDefaultList1 =  arr
                        }
                        if (that.viewData.pic_arr.length > 0) {
                            let imgList = [];
                            let thumb_arr = that.viewData.pic_arr;
                            thumb_arr.forEach((ele, index) => {
                                let obj = {
                                    name: ele,
                                    path: ele,
                                    url: that.$publicData.imgUrl + ele,
                                }
                                imgList.push(obj);
                            })
                            // 回显图
                            that.imageDefaultList = imgList
                            // console.log(that.imageDefaultList)
                        };
                    }
                });
            } else {
                // 新增
            }
        },
        /**
         * @name: 提交
         * @param {*} formName
         * @return {*}
         * @desc:
         */
         tijiao(formName) {
            let that = this
            console.log(this.viewData)
            this.$refs[formName].validate(valid => {
                if (valid) {
					if(this.viewData.id){
						// 编辑
						fetch.edit(this.viewData).then(res=>{
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						})
					}else{
						// 新增
						fetch.create(this.viewData).then(res=>{
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						})
					}

                } else {
                    this.$message.warning(this.$t('form.verifyMsg'))
                }
            })
        },
        /**
         * @name: 清空form
         * @return {*}
         * @desc:
         */
        resetForm() {
            this.$refs["ruleForm"].resetFields();
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
